var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 55
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Email_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1D6FF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1AC8FC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "url(#Email_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M33.521 28.728A1.97 1.97 0 0132.52 29H8.48a1.97 1.97 0 01-1.001-.272l8.021-8.02 1.98 1.979c.765.765 1.782 1.146 3.02 1.146s2.255-.381 3.02-1.146l1.98-1.98 8.021 8.021zm.707-.707L26.208 20l8.02-8.021c.173.293.272.636.272 1.001v14.04c0 .365-.099.708-.272 1.001zm-27.456 0A1.97 1.97 0 016.5 27.02V12.98c0-.365.099-.708.272-1.001L14.792 20l-8.02 8.021zm26.75-16.75L22.812 21.98c-.568.568-1.329.853-2.313.853-.984 0-1.745-.285-2.313-.853L7.479 11.272A1.97 1.97 0 018.48 11h24.04c.365 0 .708.099 1.001.272z"
  }))));
}

export default SvgEmail;